import React, { SVGProps } from "react";

const SvgProtrusion02 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="#bacbd8"
      d="M112.68 208.675v40.238l142.307-82.406v-28.908l-67.921-29.357-74.386 100.433z"
    />
    <path fill="#fff" d="M112.68 216.883v32.03l-14.902-21.487 14.902-10.543z" />
    <path
      fill="#45e0ff"
      d="m82.528 222.459 26.85 15.489 80.245-125.161-106.608-61.7-.487 171.372z"
    />
    <path
      fill="#255d63"
      d="M157.711 178.12v27.456l23.38-13.539v-27.456l-23.38 13.539zM185.986 161.796v27.455l23.381-13.539v-27.455l-23.381 13.539z"
    />
    <path
      fill="#2580b4"
      d="m240.622 128.099 26.85 15.489-77.849-30.801-106.608-61.7 157.607 77.012z"
    />
    <g fill="none">
      <path
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M254.987 138.594v27.913L112.68 248.913l-10.473-15.102"
      />
      <path
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        d="M112.68 248.585v-16.028"
      />
      <path
        stroke="#002839"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m83.015 51.087 106.608 61.7-80.245 125.161-26.85-15.489.487-171.372z"
      />
      <path
        stroke="#002839"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m83.015 51.087 157.607 77.012 26.85 15.489-77.849-30.801"
      />
    </g>
  </svg>
);

export default SvgProtrusion02;
